/* eslint-disable */
/* generated: do not edit! helper file for hinter. generated by update-p5-hinter script */
export const p5Hinter = [
  {
    text: 'describe',
    type: 'fun',
    params: [
      { p: 'text', o: false },
      { p: 'display', o: true }
    ],
    p5: true
  },
  {
    text: 'describeElement',
    type: 'fun',
    params: [
      { p: 'name', o: false },
      { p: 'text', o: false },
      { p: 'display', o: true }
    ],
    p5: true
  },
  {
    text: 'textOutput',
    type: 'fun',
    params: [{ p: 'display', o: true }],
    p5: true
  },
  {
    text: 'gridOutput',
    type: 'fun',
    params: [{ p: 'display', o: true }],
    p5: true
  },
  { text: 'alpha', type: 'fun', params: [{ p: 'color', o: false }], p5: true },
  { text: 'blue', type: 'fun', params: [{ p: 'color', o: false }], p5: true },
  {
    text: 'brightness',
    type: 'fun',
    params: [{ p: 'color', o: false }],
    p5: true
  },
  { text: 'color', type: 'fun', p5: true },
  { text: 'green', type: 'fun', params: [{ p: 'color', o: false }], p5: true },
  { text: 'hue', type: 'fun', params: [{ p: 'color', o: false }], p5: true },
  {
    text: 'lerpColor',
    type: 'fun',
    params: [
      { p: 'c1', o: false },
      { p: 'c2', o: false },
      { p: 'amt', o: false }
    ],
    p5: true
  },
  {
    text: 'lightness',
    type: 'fun',
    params: [{ p: 'color', o: false }],
    p5: true
  },
  { text: 'red', type: 'fun', params: [{ p: 'color', o: false }], p5: true },
  {
    text: 'saturation',
    type: 'fun',
    params: [{ p: 'color', o: false }],
    p5: true
  },
  {
    text: 'beginClip',
    type: 'fun',
    params: [{ p: 'options', o: true }],
    p5: true
  },
  { text: 'endClip', type: 'fun', p5: true },
  {
    text: 'clip',
    type: 'fun',
    params: [
      { p: 'callback', o: false },
      { p: 'options', o: true }
    ],
    p5: true
  },
  { text: 'background', type: 'fun', p5: true },
  {
    text: 'clear',
    type: 'fun',
    params: [
      { p: 'r', o: true },
      { p: 'g', o: true },
      { p: 'b', o: true },
      { p: 'a', o: true }
    ],
    p5: true
  },
  { text: 'colorMode', type: 'fun', p5: true },
  { text: 'fill', type: 'fun', p5: true },
  { text: 'noFill', type: 'fun', p5: true },
  { text: 'noStroke', type: 'fun', p5: true },
  { text: 'stroke', type: 'fun', p5: true },
  {
    text: 'erase',
    type: 'fun',
    params: [
      { p: 'strengthFill', o: true },
      { p: 'strengthStroke', o: true }
    ],
    p5: true
  },
  { text: 'noErase', type: 'fun', p5: true },
  {
    text: 'arc',
    type: 'fun',
    params: [
      { p: 'x', o: false },
      { p: 'y', o: false },
      { p: 'w', o: false },
      { p: 'h', o: false },
      { p: 'start', o: false },
      { p: 'stop', o: false },
      { p: 'mode', o: true },
      { p: 'detail', o: true }
    ],
    p5: true
  },
  { text: 'ellipse', type: 'fun', p5: true },
  {
    text: 'circle',
    type: 'fun',
    params: [
      { p: 'x', o: false },
      { p: 'y', o: false },
      { p: 'd', o: false }
    ],
    p5: true
  },
  { text: 'line', type: 'fun', p5: true },
  { text: 'point', type: 'fun', p5: true },
  { text: 'quad', type: 'fun', p5: true },
  { text: 'rect', type: 'fun', p5: true },
  {
    text: 'square',
    type: 'fun',
    params: [
      { p: 'x', o: false },
      { p: 'y', o: false },
      { p: 's', o: false },
      { p: 'tl', o: true },
      { p: 'tr', o: true },
      { p: 'br', o: true },
      { p: 'bl', o: true }
    ],
    p5: true
  },
  {
    text: 'triangle',
    type: 'fun',
    params: [
      { p: 'x1', o: false },
      { p: 'y1', o: false },
      { p: 'x2', o: false },
      { p: 'y2', o: false },
      { p: 'x3', o: false },
      { p: 'y3', o: false }
    ],
    p5: true
  },
  {
    text: 'ellipseMode',
    type: 'fun',
    params: [{ p: 'mode', o: false }],
    p5: true
  },
  { text: 'noSmooth', type: 'fun', p5: true },
  {
    text: 'rectMode',
    type: 'fun',
    params: [{ p: 'mode', o: false }],
    p5: true
  },
  { text: 'smooth', type: 'fun', p5: true },
  {
    text: 'strokeCap',
    type: 'fun',
    params: [{ p: 'cap', o: false }],
    p5: true
  },
  {
    text: 'strokeJoin',
    type: 'fun',
    params: [{ p: 'join', o: false }],
    p5: true
  },
  {
    text: 'strokeWeight',
    type: 'fun',
    params: [{ p: 'weight', o: false }],
    p5: true
  },
  { text: 'bezier', type: 'fun', p5: true },
  {
    text: 'bezierDetail',
    type: 'fun',
    params: [{ p: 'detail', o: false }],
    p5: true
  },
  {
    text: 'bezierPoint',
    type: 'fun',
    params: [
      { p: 'a', o: false },
      { p: 'b', o: false },
      { p: 'c', o: false },
      { p: 'd', o: false },
      { p: 't', o: false }
    ],
    p5: true
  },
  {
    text: 'bezierTangent',
    type: 'fun',
    params: [
      { p: 'a', o: false },
      { p: 'b', o: false },
      { p: 'c', o: false },
      { p: 'd', o: false },
      { p: 't', o: false }
    ],
    p5: true
  },
  { text: 'curve', type: 'fun', p5: true },
  {
    text: 'curveDetail',
    type: 'fun',
    params: [{ p: 'resolution', o: false }],
    p5: true
  },
  {
    text: 'curveTightness',
    type: 'fun',
    params: [{ p: 'amount', o: false }],
    p5: true
  },
  {
    text: 'curvePoint',
    type: 'fun',
    params: [
      { p: 'a', o: false },
      { p: 'b', o: false },
      { p: 'c', o: false },
      { p: 'd', o: false },
      { p: 't', o: false }
    ],
    p5: true
  },
  {
    text: 'curveTangent',
    type: 'fun',
    params: [
      { p: 'a', o: false },
      { p: 'b', o: false },
      { p: 'c', o: false },
      { p: 'd', o: false },
      { p: 't', o: false }
    ],
    p5: true
  },
  { text: 'beginContour', type: 'fun', p5: true },
  {
    text: 'beginShape',
    type: 'fun',
    params: [{ p: 'kind', o: true }],
    p5: true
  },
  { text: 'bezierVertex', type: 'fun', p5: true },
  { text: 'curveVertex', type: 'fun', p5: true },
  { text: 'endContour', type: 'fun', p5: true },
  {
    text: 'endShape',
    type: 'fun',
    params: [
      { p: 'mode', o: true },
      { p: 'count', o: true }
    ],
    p5: true
  },
  { text: 'quadraticVertex', type: 'fun', p5: true },
  { text: 'vertex', type: 'fun', p5: true },
  { text: 'normal', type: 'fun', p5: true },
  { text: 'VERSION', type: 'var', params: [], p5: true },
  { text: 'P2D', type: 'var', params: [], p5: true },
  { text: 'WEBGL', type: 'var', params: [], p5: true },
  { text: 'WEBGL2', type: 'var', params: [], p5: true },
  { text: 'ARROW', type: 'var', params: [], p5: true },
  { text: 'CROSS', type: 'var', params: [], p5: true },
  { text: 'HAND', type: 'var', params: [], p5: true },
  { text: 'MOVE', type: 'var', params: [], p5: true },
  { text: 'TEXT', type: 'var', params: [], p5: true },
  { text: 'WAIT', type: 'var', params: [], p5: true },
  { text: 'HALF_PI', type: 'var', params: [], p5: true },
  { text: 'PI', type: 'var', params: [], p5: true },
  { text: 'QUARTER_PI', type: 'var', params: [], p5: true },
  { text: 'TAU', type: 'var', params: [], p5: true },
  { text: 'TWO_PI', type: 'var', params: [], p5: true },
  { text: 'DEGREES', type: 'var', params: [], p5: true },
  { text: 'RADIANS', type: 'var', params: [], p5: true },
  { text: 'CORNER', type: 'var', params: [], p5: true },
  { text: 'CORNERS', type: 'var', params: [], p5: true },
  { text: 'RADIUS', type: 'var', params: [], p5: true },
  { text: 'RIGHT', type: 'var', params: [], p5: true },
  { text: 'LEFT', type: 'var', params: [], p5: true },
  { text: 'CENTER', type: 'var', params: [], p5: true },
  { text: 'TOP', type: 'var', params: [], p5: true },
  { text: 'BOTTOM', type: 'var', params: [], p5: true },
  { text: 'BASELINE', type: 'var', params: [], p5: true },
  { text: 'POINTS', type: 'var', params: [], p5: true },
  { text: 'LINES', type: 'var', params: [], p5: true },
  { text: 'LINE_STRIP', type: 'var', params: [], p5: true },
  { text: 'LINE_LOOP', type: 'var', params: [], p5: true },
  { text: 'TRIANGLES', type: 'var', params: [], p5: true },
  { text: 'TRIANGLE_FAN', type: 'var', params: [], p5: true },
  { text: 'TRIANGLE_STRIP', type: 'var', params: [], p5: true },
  { text: 'QUADS', type: 'var', params: [], p5: true },
  { text: 'QUAD_STRIP', type: 'var', params: [], p5: true },
  { text: 'TESS', type: 'var', params: [], p5: true },
  { text: 'CLOSE', type: 'var', params: [], p5: true },
  { text: 'OPEN', type: 'var', params: [], p5: true },
  { text: 'CHORD', type: 'var', params: [], p5: true },
  { text: 'PIE', type: 'var', params: [], p5: true },
  { text: 'PROJECT', type: 'var', params: [], p5: true },
  { text: 'SQUARE', type: 'var', params: [], p5: true },
  { text: 'ROUND', type: 'var', params: [], p5: true },
  { text: 'BEVEL', type: 'var', params: [], p5: true },
  { text: 'MITER', type: 'var', params: [], p5: true },
  { text: 'RGB', type: 'var', params: [], p5: true },
  { text: 'HSB', type: 'var', params: [], p5: true },
  { text: 'HSL', type: 'var', params: [], p5: true },
  { text: 'AUTO', type: 'var', params: [], p5: true },
  { text: 'ALT', type: 'var', params: [], p5: true },
  { text: 'BACKSPACE', type: 'var', params: [], p5: true },
  { text: 'CONTROL', type: 'var', params: [], p5: true },
  { text: 'DELETE', type: 'var', params: [], p5: true },
  { text: 'DOWN_ARROW', type: 'var', params: [], p5: true },
  { text: 'ENTER', type: 'var', params: [], p5: true },
  { text: 'ESCAPE', type: 'var', params: [], p5: true },
  { text: 'LEFT_ARROW', type: 'var', params: [], p5: true },
  { text: 'OPTION', type: 'var', params: [], p5: true },
  { text: 'RETURN', type: 'var', params: [], p5: true },
  { text: 'RIGHT_ARROW', type: 'var', params: [], p5: true },
  { text: 'SHIFT', type: 'var', params: [], p5: true },
  { text: 'TAB', type: 'var', params: [], p5: true },
  { text: 'UP_ARROW', type: 'var', params: [], p5: true },
  { text: 'BLEND', type: 'var', params: [], p5: true },
  { text: 'REMOVE', type: 'var', params: [], p5: true },
  { text: 'ADD', type: 'var', params: [], p5: true },
  { text: 'DARKEST', type: 'var', params: [], p5: true },
  { text: 'LIGHTEST', type: 'var', params: [], p5: true },
  { text: 'DIFFERENCE', type: 'var', params: [], p5: true },
  { text: 'SUBTRACT', type: 'var', params: [], p5: true },
  { text: 'EXCLUSION', type: 'var', params: [], p5: true },
  { text: 'MULTIPLY', type: 'var', params: [], p5: true },
  { text: 'SCREEN', type: 'var', params: [], p5: true },
  { text: 'REPLACE', type: 'var', params: [], p5: true },
  { text: 'OVERLAY', type: 'var', params: [], p5: true },
  { text: 'HARD_LIGHT', type: 'var', params: [], p5: true },
  { text: 'SOFT_LIGHT', type: 'var', params: [], p5: true },
  { text: 'DODGE', type: 'var', params: [], p5: true },
  { text: 'BURN', type: 'var', params: [], p5: true },
  { text: 'THRESHOLD', type: 'var', params: [], p5: true },
  { text: 'GRAY', type: 'var', params: [], p5: true },
  { text: 'OPAQUE', type: 'var', params: [], p5: true },
  { text: 'INVERT', type: 'var', params: [], p5: true },
  { text: 'POSTERIZE', type: 'var', params: [], p5: true },
  { text: 'DILATE', type: 'var', params: [], p5: true },
  { text: 'ERODE', type: 'var', params: [], p5: true },
  { text: 'BLUR', type: 'var', params: [], p5: true },
  { text: 'NORMAL', type: 'var', params: [], p5: true },
  { text: 'ITALIC', type: 'var', params: [], p5: true },
  { text: 'BOLD', type: 'var', params: [], p5: true },
  { text: 'BOLDITALIC', type: 'var', params: [], p5: true },
  { text: 'CHAR', type: 'var', params: [], p5: true },
  { text: 'WORD', type: 'var', params: [], p5: true },
  { text: 'LINEAR', type: 'var', params: [], p5: true },
  { text: 'QUADRATIC', type: 'var', params: [], p5: true },
  { text: 'BEZIER', type: 'var', params: [], p5: true },
  { text: 'CURVE', type: 'var', params: [], p5: true },
  { text: 'STROKE', type: 'var', params: [], p5: true },
  { text: 'FILL', type: 'var', params: [], p5: true },
  { text: 'TEXTURE', type: 'var', params: [], p5: true },
  { text: 'IMMEDIATE', type: 'var', params: [], p5: true },
  { text: 'IMAGE', type: 'var', params: [], p5: true },
  { text: 'NEAREST', type: 'var', params: [], p5: true },
  { text: 'REPEAT', type: 'var', params: [], p5: true },
  { text: 'CLAMP', type: 'var', params: [], p5: true },
  { text: 'MIRROR', type: 'var', params: [], p5: true },
  { text: 'FLAT', type: 'var', params: [], p5: true },
  { text: 'SMOOTH', type: 'var', params: [], p5: true },
  { text: 'LANDSCAPE', type: 'var', params: [], p5: true },
  { text: 'PORTRAIT', type: 'var', params: [], p5: true },
  { text: 'GRID', type: 'var', params: [], p5: true },
  { text: 'AXES', type: 'var', params: [], p5: true },
  { text: 'LABEL', type: 'var', params: [], p5: true },
  { text: 'FALLBACK', type: 'var', params: [], p5: true },
  { text: 'CONTAIN', type: 'var', params: [], p5: true },
  { text: 'COVER', type: 'var', params: [], p5: true },
  { text: 'UNSIGNED_BYTE', type: 'var', params: [], p5: true },
  { text: 'UNSIGNED_INT', type: 'var', params: [], p5: true },
  { text: 'FLOAT', type: 'var', params: [], p5: true },
  { text: 'HALF_FLOAT', type: 'var', params: [], p5: true },
  { text: 'RGBA', type: 'var', params: [], p5: true },
  {
    text: 'print',
    type: 'fun',
    params: [{ p: 'contents', o: false }],
    p5: true
  },
  { text: 'frameCount', type: 'var', params: [], p5: true },
  { text: 'deltaTime', type: 'var', params: [], p5: true },
  { text: 'focused', type: 'var', params: [], p5: true },
  {
    text: 'cursor',
    type: 'fun',
    params: [
      { p: 'type', o: false },
      { p: 'x', o: true },
      { p: 'y', o: true }
    ],
    p5: true
  },
  { text: 'frameRate', type: 'fun', p5: true },
  { text: 'getTargetFrameRate', type: 'fun', p5: true },
  { text: 'noCursor', type: 'fun', p5: true },
  { text: 'webglVersion', type: 'var', params: [], p5: true },
  { text: 'displayWidth', type: 'var', params: [], p5: true },
  { text: 'displayHeight', type: 'var', params: [], p5: true },
  { text: 'windowWidth', type: 'var', params: [], p5: true },
  { text: 'windowHeight', type: 'var', params: [], p5: true },
  {
    text: 'windowResized',
    type: 'fun',
    params: [{ p: 'event', o: true }],
    p5: true
  },
  { text: 'width', type: 'var', params: [], p5: true },
  { text: 'height', type: 'var', params: [], p5: true },
  {
    text: 'fullscreen',
    type: 'fun',
    params: [{ p: 'val', o: true }],
    p5: true
  },
  { text: 'pixelDensity', type: 'fun', p5: true },
  { text: 'displayDensity', type: 'fun', p5: true },
  { text: 'getURL', type: 'fun', p5: true },
  { text: 'getURLPath', type: 'fun', p5: true },
  { text: 'getURLParams', type: 'fun', p5: true },
  { text: 'preload', type: 'fun', p5: true },
  { text: 'setup', type: 'fun', p5: true },
  { text: 'draw', type: 'fun', p5: true },
  { text: 'remove', type: 'fun', p5: true },
  { text: 'disableFriendlyErrors', type: 'var', params: [], p5: true },
  { text: 'createCanvas', type: 'fun', p5: true },
  {
    text: 'resizeCanvas',
    type: 'fun',
    params: [
      { p: 'width', o: false },
      { p: 'height', o: false },
      { p: 'noRedraw', o: true }
    ],
    p5: true
  },
  { text: 'noCanvas', type: 'fun', p5: true },
  { text: 'createGraphics', type: 'fun', p5: true },
  {
    text: 'createFramebuffer',
    type: 'fun',
    params: [{ p: 'options', o: true }],
    p5: true
  },
  {
    text: 'clearDepth',
    type: 'fun',
    params: [{ p: 'depth', o: true }],
    p5: true
  },
  {
    text: 'blendMode',
    type: 'fun',
    params: [{ p: 'mode', o: false }],
    p5: true
  },
  { text: 'drawingContext', type: 'var', params: [], p5: true },
  { text: 'noLoop', type: 'fun', p5: true },
  { text: 'loop', type: 'fun', p5: true },
  { text: 'isLooping', type: 'fun', p5: true },
  { text: 'push', type: 'fun', p5: true },
  { text: 'pop', type: 'fun', p5: true },
  { text: 'redraw', type: 'fun', params: [{ p: 'n', o: true }], p5: true },
  {
    text: 'p5',
    type: 'fun',
    params: [
      { p: 'sketch', o: false },
      { p: 'node', o: false }
    ],
    p5: true
  },
  { text: 'applyMatrix', type: 'fun', p5: true },
  { text: 'resetMatrix', type: 'fun', p5: true },
  {
    text: 'rotate',
    type: 'fun',
    params: [
      { p: 'angle', o: false },
      { p: 'axis', o: true }
    ],
    p5: true
  },
  {
    text: 'rotateX',
    type: 'fun',
    params: [{ p: 'angle', o: false }],
    p5: true
  },
  {
    text: 'rotateY',
    type: 'fun',
    params: [{ p: 'angle', o: false }],
    p5: true
  },
  {
    text: 'rotateZ',
    type: 'fun',
    params: [{ p: 'angle', o: false }],
    p5: true
  },
  { text: 'scale', type: 'fun', p5: true },
  { text: 'shearX', type: 'fun', params: [{ p: 'angle', o: false }], p5: true },
  { text: 'shearY', type: 'fun', params: [{ p: 'angle', o: false }], p5: true },
  { text: 'translate', type: 'fun', p5: true },
  {
    text: 'storeItem',
    type: 'fun',
    params: [
      { p: 'key', o: false },
      { p: 'value', o: false }
    ],
    p5: true
  },
  { text: 'getItem', type: 'fun', params: [{ p: 'key', o: false }], p5: true },
  { text: 'clearStorage', type: 'fun', p5: true },
  {
    text: 'removeItem',
    type: 'fun',
    params: [{ p: 'key', o: false }],
    p5: true
  },
  { text: 'createStringDict', type: 'fun', p5: true },
  { text: 'createNumberDict', type: 'fun', p5: true },
  {
    text: 'select',
    type: 'fun',
    params: [
      { p: 'selectors', o: false },
      { p: 'container', o: true }
    ],
    p5: true
  },
  {
    text: 'selectAll',
    type: 'fun',
    params: [
      { p: 'selectors', o: false },
      { p: 'container', o: true }
    ],
    p5: true
  },
  { text: 'removeElements', type: 'fun', p5: true },
  { text: 'changed', type: 'fun', params: [{ p: 'fxn', o: false }], p5: true },
  { text: 'input', type: 'fun', params: [{ p: 'fxn', o: false }], p5: true },
  {
    text: 'createDiv',
    type: 'fun',
    params: [{ p: 'html', o: true }],
    p5: true
  },
  { text: 'createP', type: 'fun', params: [{ p: 'html', o: true }], p5: true },
  {
    text: 'createSpan',
    type: 'fun',
    params: [{ p: 'html', o: true }],
    p5: true
  },
  { text: 'createImg', type: 'fun', p5: true },
  {
    text: 'createA',
    type: 'fun',
    params: [
      { p: 'href', o: false },
      { p: 'html', o: false },
      { p: 'target', o: true }
    ],
    p5: true
  },
  {
    text: 'createSlider',
    type: 'fun',
    params: [
      { p: 'min', o: false },
      { p: 'max', o: false },
      { p: 'value', o: true },
      { p: 'step', o: true }
    ],
    p5: true
  },
  {
    text: 'createButton',
    type: 'fun',
    params: [
      { p: 'label', o: false },
      { p: 'value', o: true }
    ],
    p5: true
  },
  {
    text: 'createCheckbox',
    type: 'fun',
    params: [
      { p: 'label', o: true },
      { p: 'value', o: true }
    ],
    p5: true
  },
  { text: 'createSelect', type: 'fun', p5: true },
  { text: 'createRadio', type: 'fun', p5: true },
  {
    text: 'createColorPicker',
    type: 'fun',
    params: [{ p: 'value', o: true }],
    p5: true
  },
  { text: 'createInput', type: 'fun', p5: true },
  {
    text: 'createFileInput',
    type: 'fun',
    params: [
      { p: 'callback', o: false },
      { p: 'multiple', o: true }
    ],
    p5: true
  },
  {
    text: 'createVideo',
    type: 'fun',
    params: [
      { p: 'src', o: false },
      { p: 'callback', o: true }
    ],
    p5: true
  },
  {
    text: 'createAudio',
    type: 'fun',
    params: [
      { p: 'src', o: true },
      { p: 'callback', o: true }
    ],
    p5: true
  },
  {
    text: 'createCapture',
    type: 'fun',
    params: [
      { p: 'type', o: true },
      { p: 'flipped', o: true },
      { p: 'callback', o: true }
    ],
    p5: true
  },
  {
    text: 'createElement',
    type: 'fun',
    params: [
      { p: 'tag', o: false },
      { p: 'content', o: true }
    ],
    p5: true
  },
  { text: 'deviceOrientation', type: 'var', params: [], p5: true },
  { text: 'accelerationX', type: 'var', params: [], p5: true },
  { text: 'accelerationY', type: 'var', params: [], p5: true },
  { text: 'accelerationZ', type: 'var', params: [], p5: true },
  { text: 'pAccelerationX', type: 'var', params: [], p5: true },
  { text: 'pAccelerationY', type: 'var', params: [], p5: true },
  { text: 'pAccelerationZ', type: 'var', params: [], p5: true },
  { text: 'rotationX', type: 'var', params: [], p5: true },
  { text: 'rotationY', type: 'var', params: [], p5: true },
  { text: 'rotationZ', type: 'var', params: [], p5: true },
  { text: 'pRotationX', type: 'var', params: [], p5: true },
  { text: 'pRotationY', type: 'var', params: [], p5: true },
  { text: 'pRotationZ', type: 'var', params: [], p5: true },
  { text: 'turnAxis', type: 'var', params: [], p5: true },
  {
    text: 'setMoveThreshold',
    type: 'fun',
    params: [{ p: 'value', o: false }],
    p5: true
  },
  {
    text: 'setShakeThreshold',
    type: 'fun',
    params: [{ p: 'value', o: false }],
    p5: true
  },
  { text: 'deviceMoved', type: 'fun', p5: true },
  { text: 'deviceTurned', type: 'fun', p5: true },
  { text: 'deviceShaken', type: 'fun', p5: true },
  { text: 'keyIsPressed', type: 'var', params: [], p5: true },
  { text: 'key', type: 'var', params: [], p5: true },
  { text: 'keyCode', type: 'var', params: [], p5: true },
  {
    text: 'keyPressed',
    type: 'fun',
    params: [{ p: 'event', o: true }],
    p5: true
  },
  {
    text: 'keyReleased',
    type: 'fun',
    params: [{ p: 'event', o: true }],
    p5: true
  },
  {
    text: 'keyTyped',
    type: 'fun',
    params: [{ p: 'event', o: true }],
    p5: true
  },
  {
    text: 'keyIsDown',
    type: 'fun',
    params: [{ p: 'code', o: false }],
    p5: true
  },
  { text: 'movedX', type: 'var', params: [], p5: true },
  { text: 'movedY', type: 'var', params: [], p5: true },
  { text: 'mouseX', type: 'var', params: [], p5: true },
  { text: 'mouseY', type: 'var', params: [], p5: true },
  { text: 'pmouseX', type: 'var', params: [], p5: true },
  { text: 'pmouseY', type: 'var', params: [], p5: true },
  { text: 'winMouseX', type: 'var', params: [], p5: true },
  { text: 'winMouseY', type: 'var', params: [], p5: true },
  { text: 'pwinMouseX', type: 'var', params: [], p5: true },
  { text: 'pwinMouseY', type: 'var', params: [], p5: true },
  { text: 'mouseButton', type: 'var', params: [], p5: true },
  { text: 'mouseIsPressed', type: 'var', params: [], p5: true },
  {
    text: 'mouseMoved',
    type: 'fun',
    params: [{ p: 'event', o: true }],
    p5: true
  },
  {
    text: 'mouseDragged',
    type: 'fun',
    params: [{ p: 'event', o: true }],
    p5: true
  },
  {
    text: 'mousePressed',
    type: 'fun',
    params: [{ p: 'event', o: true }],
    p5: true
  },
  {
    text: 'mouseReleased',
    type: 'fun',
    params: [{ p: 'event', o: true }],
    p5: true
  },
  {
    text: 'mouseClicked',
    type: 'fun',
    params: [{ p: 'event', o: true }],
    p5: true
  },
  {
    text: 'doubleClicked',
    type: 'fun',
    params: [{ p: 'event', o: true }],
    p5: true
  },
  {
    text: 'mouseWheel',
    type: 'fun',
    params: [{ p: 'event', o: true }],
    p5: true
  },
  { text: 'requestPointerLock', type: 'fun', p5: true },
  { text: 'exitPointerLock', type: 'fun', p5: true },
  { text: 'touches', type: 'var', params: [], p5: true },
  {
    text: 'touchStarted',
    type: 'fun',
    params: [{ p: 'event', o: true }],
    p5: true
  },
  {
    text: 'touchMoved',
    type: 'fun',
    params: [{ p: 'event', o: true }],
    p5: true
  },
  {
    text: 'touchEnded',
    type: 'fun',
    params: [{ p: 'event', o: true }],
    p5: true
  },
  {
    text: 'createImage',
    type: 'fun',
    params: [
      { p: 'width', o: false },
      { p: 'height', o: false }
    ],
    p5: true
  },
  { text: 'saveCanvas', type: 'fun', p5: true },
  {
    text: 'saveFrames',
    type: 'fun',
    params: [
      { p: 'filename', o: false },
      { p: 'extension', o: false },
      { p: 'duration', o: false },
      { p: 'framerate', o: false },
      { p: 'callback', o: true }
    ],
    p5: true
  },
  {
    text: 'loadImage',
    type: 'fun',
    params: [
      { p: 'path', o: false },
      { p: 'successCallback', o: true },
      { p: 'failureCallback', o: true }
    ],
    p5: true
  },
  {
    text: 'saveGif',
    type: 'fun',
    params: [
      { p: 'filename', o: false },
      { p: 'duration', o: false },
      { p: 'options', o: true }
    ],
    p5: true
  },
  { text: 'image', type: 'fun', p5: true },
  { text: 'tint', type: 'fun', p5: true },
  { text: 'noTint', type: 'fun', p5: true },
  {
    text: 'imageMode',
    type: 'fun',
    params: [{ p: 'mode', o: false }],
    p5: true
  },
  { text: 'pixels', type: 'var', params: [], p5: true },
  { text: 'blend', type: 'fun', p5: true },
  { text: 'copy', type: 'fun', p5: true },
  { text: 'filter', type: 'fun', p5: true },
  { text: 'get', type: 'fun', p5: true },
  { text: 'loadPixels', type: 'fun', p5: true },
  {
    text: 'set',
    type: 'fun',
    params: [
      { p: 'x', o: false },
      { p: 'y', o: false },
      { p: 'c', o: false }
    ],
    p5: true
  },
  {
    text: 'updatePixels',
    type: 'fun',
    params: [
      { p: 'x', o: true },
      { p: 'y', o: true },
      { p: 'w', o: true },
      { p: 'h', o: true }
    ],
    p5: true
  },
  {
    text: 'loadJSON',
    type: 'fun',
    params: [
      { p: 'path', o: false },
      { p: 'successCallback', o: true },
      { p: 'errorCallback', o: true }
    ],
    p5: true
  },
  {
    text: 'loadStrings',
    type: 'fun',
    params: [
      { p: 'path', o: false },
      { p: 'successCallback', o: true },
      { p: 'errorCallback', o: true }
    ],
    p5: true
  },
  {
    text: 'loadTable',
    type: 'fun',
    params: [
      { p: 'filename', o: false },
      { p: 'extension', o: true },
      { p: 'header', o: true },
      { p: 'callback', o: true },
      { p: 'errorCallback', o: true }
    ],
    p5: true
  },
  {
    text: 'loadXML',
    type: 'fun',
    params: [
      { p: 'path', o: false },
      { p: 'successCallback', o: true },
      { p: 'errorCallback', o: true }
    ],
    p5: true
  },
  {
    text: 'loadBytes',
    type: 'fun',
    params: [
      { p: 'file', o: false },
      { p: 'callback', o: true },
      { p: 'errorCallback', o: true }
    ],
    p5: true
  },
  { text: 'httpGet', type: 'fun', p5: true },
  { text: 'httpPost', type: 'fun', p5: true },
  { text: 'httpDo', type: 'fun', p5: true },
  {
    text: 'createWriter',
    type: 'fun',
    params: [
      { p: 'name', o: false },
      { p: 'extension', o: true }
    ],
    p5: true
  },
  {
    text: 'save',
    type: 'fun',
    params: [
      { p: 'objectOrFilename', o: true },
      { p: 'filename', o: true },
      { p: 'options', o: true }
    ],
    p5: true
  },
  {
    text: 'saveJSON',
    type: 'fun',
    params: [
      { p: 'json', o: false },
      { p: 'filename', o: false },
      { p: 'optimize', o: true }
    ],
    p5: true
  },
  {
    text: 'saveStrings',
    type: 'fun',
    params: [
      { p: 'list', o: false },
      { p: 'filename', o: false },
      { p: 'extension', o: true },
      { p: 'isCRLF', o: true }
    ],
    p5: true
  },
  {
    text: 'saveTable',
    type: 'fun',
    params: [
      { p: 'Table', o: false },
      { p: 'filename', o: false },
      { p: 'options', o: true }
    ],
    p5: true
  },
  { text: 'abs', type: 'fun', params: [{ p: 'n', o: false }], p5: true },
  { text: 'ceil', type: 'fun', params: [{ p: 'n', o: false }], p5: true },
  {
    text: 'constrain',
    type: 'fun',
    params: [
      { p: 'n', o: false },
      { p: 'low', o: false },
      { p: 'high', o: false }
    ],
    p5: true
  },
  { text: 'dist', type: 'fun', p5: true },
  { text: 'exp', type: 'fun', params: [{ p: 'n', o: false }], p5: true },
  { text: 'floor', type: 'fun', params: [{ p: 'n', o: false }], p5: true },
  {
    text: 'lerp',
    type: 'fun',
    params: [
      { p: 'start', o: false },
      { p: 'stop', o: false },
      { p: 'amt', o: false }
    ],
    p5: true
  },
  { text: 'log', type: 'fun', params: [{ p: 'n', o: false }], p5: true },
  {
    text: 'mag',
    type: 'fun',
    params: [
      { p: 'x', o: false },
      { p: 'y', o: false }
    ],
    p5: true
  },
  {
    text: 'map',
    type: 'fun',
    params: [
      { p: 'value', o: false },
      { p: 'start1', o: false },
      { p: 'stop1', o: false },
      { p: 'start2', o: false },
      { p: 'stop2', o: false },
      { p: 'withinBounds', o: true }
    ],
    p5: true
  },
  { text: 'max', type: 'fun', p5: true },
  { text: 'min', type: 'fun', p5: true },
  {
    text: 'norm',
    type: 'fun',
    params: [
      { p: 'value', o: false },
      { p: 'start', o: false },
      { p: 'stop', o: false }
    ],
    p5: true
  },
  {
    text: 'pow',
    type: 'fun',
    params: [
      { p: 'n', o: false },
      { p: 'e', o: false }
    ],
    p5: true
  },
  {
    text: 'round',
    type: 'fun',
    params: [
      { p: 'n', o: false },
      { p: 'decimals', o: true }
    ],
    p5: true
  },
  { text: 'sq', type: 'fun', params: [{ p: 'n', o: false }], p5: true },
  { text: 'sqrt', type: 'fun', params: [{ p: 'n', o: false }], p5: true },
  { text: 'fract', type: 'fun', params: [{ p: 'n', o: false }], p5: true },
  {
    text: 'createVector',
    type: 'fun',
    params: [
      { p: 'x', o: true },
      { p: 'y', o: true },
      { p: 'z', o: true }
    ],
    p5: true
  },
  {
    text: 'noise',
    type: 'fun',
    params: [
      { p: 'x', o: false },
      { p: 'y', o: true },
      { p: 'z', o: true }
    ],
    p5: true
  },
  {
    text: 'noiseDetail',
    type: 'fun',
    params: [
      { p: 'lod', o: false },
      { p: 'falloff', o: false }
    ],
    p5: true
  },
  {
    text: 'noiseSeed',
    type: 'fun',
    params: [{ p: 'seed', o: false }],
    p5: true
  },
  {
    text: 'randomSeed',
    type: 'fun',
    params: [{ p: 'seed', o: false }],
    p5: true
  },
  { text: 'random', type: 'fun', p5: true },
  {
    text: 'randomGaussian',
    type: 'fun',
    params: [
      { p: 'mean', o: true },
      { p: 'sd', o: true }
    ],
    p5: true
  },
  { text: 'acos', type: 'fun', params: [{ p: 'value', o: false }], p5: true },
  { text: 'asin', type: 'fun', params: [{ p: 'value', o: false }], p5: true },
  { text: 'atan', type: 'fun', params: [{ p: 'value', o: false }], p5: true },
  {
    text: 'atan2',
    type: 'fun',
    params: [
      { p: 'y', o: false },
      { p: 'x', o: false }
    ],
    p5: true
  },
  { text: 'cos', type: 'fun', params: [{ p: 'angle', o: false }], p5: true },
  { text: 'sin', type: 'fun', params: [{ p: 'angle', o: false }], p5: true },
  { text: 'tan', type: 'fun', params: [{ p: 'angle', o: false }], p5: true },
  {
    text: 'degrees',
    type: 'fun',
    params: [{ p: 'radians', o: false }],
    p5: true
  },
  {
    text: 'radians',
    type: 'fun',
    params: [{ p: 'degrees', o: false }],
    p5: true
  },
  { text: 'angleMode', type: 'fun', p5: true },
  { text: 'textAlign', type: 'fun', p5: true },
  { text: 'textLeading', type: 'fun', p5: true },
  { text: 'textSize', type: 'fun', p5: true },
  { text: 'textStyle', type: 'fun', p5: true },
  {
    text: 'textWidth',
    type: 'fun',
    params: [{ p: 'str', o: false }],
    p5: true
  },
  { text: 'textAscent', type: 'fun', p5: true },
  { text: 'textDescent', type: 'fun', p5: true },
  {
    text: 'textWrap',
    type: 'fun',
    params: [{ p: 'style', o: false }],
    p5: true
  },
  {
    text: 'loadFont',
    type: 'fun',
    params: [
      { p: 'path', o: false },
      { p: 'successCallback', o: true },
      { p: 'failureCallback', o: true }
    ],
    p5: true
  },
  {
    text: 'text',
    type: 'fun',
    params: [
      { p: 'str', o: false },
      { p: 'x', o: false },
      { p: 'y', o: false },
      { p: 'maxWidth', o: true },
      { p: 'maxHeight', o: true }
    ],
    p5: true
  },
  { text: 'textFont', type: 'fun', p5: true },
  {
    text: 'append',
    type: 'fun',
    params: [
      { p: 'array', o: false },
      { p: 'value', o: false }
    ],
    p5: true
  },
  { text: 'arrayCopy', type: 'fun', p5: true },
  {
    text: 'concat',
    type: 'fun',
    params: [
      { p: 'a', o: false },
      { p: 'b', o: false }
    ],
    p5: true
  },
  { text: 'reverse', type: 'fun', params: [{ p: 'list', o: false }], p5: true },
  { text: 'shorten', type: 'fun', params: [{ p: 'list', o: false }], p5: true },
  {
    text: 'shuffle',
    type: 'fun',
    params: [
      { p: 'array', o: false },
      { p: 'bool', o: true }
    ],
    p5: true
  },
  {
    text: 'sort',
    type: 'fun',
    params: [
      { p: 'list', o: false },
      { p: 'count', o: true }
    ],
    p5: true
  },
  {
    text: 'splice',
    type: 'fun',
    params: [
      { p: 'list', o: false },
      { p: 'value', o: false },
      { p: 'position', o: false }
    ],
    p5: true
  },
  {
    text: 'subset',
    type: 'fun',
    params: [
      { p: 'list', o: false },
      { p: 'start', o: false },
      { p: 'count', o: true }
    ],
    p5: true
  },
  { text: 'float', type: 'fun', p5: true },
  { text: 'int', type: 'fun', p5: true },
  { text: 'str', type: 'fun', params: [{ p: 'n', o: false }], p5: true },
  { text: 'boolean', type: 'fun', p5: true },
  { text: 'byte', type: 'fun', p5: true },
  { text: 'char', type: 'fun', p5: true },
  { text: 'unchar', type: 'fun', p5: true },
  { text: 'hex', type: 'fun', p5: true },
  { text: 'unhex', type: 'fun', p5: true },
  {
    text: 'join',
    type: 'fun',
    params: [
      { p: 'list', o: false },
      { p: 'separator', o: false }
    ],
    p5: true
  },
  {
    text: 'match',
    type: 'fun',
    params: [
      { p: 'str', o: false },
      { p: 'regexp', o: false }
    ],
    p5: true
  },
  {
    text: 'matchAll',
    type: 'fun',
    params: [
      { p: 'str', o: false },
      { p: 'regexp', o: false }
    ],
    p5: true
  },
  { text: 'nf', type: 'fun', p5: true },
  { text: 'nfc', type: 'fun', p5: true },
  { text: 'nfp', type: 'fun', p5: true },
  { text: 'nfs', type: 'fun', p5: true },
  {
    text: 'split',
    type: 'fun',
    params: [
      { p: 'value', o: false },
      { p: 'delim', o: false }
    ],
    p5: true
  },
  {
    text: 'splitTokens',
    type: 'fun',
    params: [
      { p: 'value', o: false },
      { p: 'delim', o: true }
    ],
    p5: true
  },
  { text: 'trim', type: 'fun', p5: true },
  { text: 'day', type: 'fun', p5: true },
  { text: 'hour', type: 'fun', p5: true },
  { text: 'minute', type: 'fun', p5: true },
  { text: 'millis', type: 'fun', p5: true },
  { text: 'month', type: 'fun', p5: true },
  { text: 'second', type: 'fun', p5: true },
  { text: 'year', type: 'fun', p5: true },
  { text: 'beginGeometry', type: 'fun', p5: true },
  { text: 'endGeometry', type: 'fun', p5: true },
  {
    text: 'buildGeometry',
    type: 'fun',
    params: [{ p: 'callback', o: false }],
    p5: true
  },
  {
    text: 'freeGeometry',
    type: 'fun',
    params: [{ p: 'geometry', o: false }],
    p5: true
  },
  {
    text: 'plane',
    type: 'fun',
    params: [
      { p: 'width', o: true },
      { p: 'height', o: true },
      { p: 'detailX', o: true },
      { p: 'detailY', o: true }
    ],
    p5: true
  },
  {
    text: 'box',
    type: 'fun',
    params: [
      { p: 'width', o: true },
      { p: 'height', o: true },
      { p: 'depth', o: true },
      { p: 'detailX', o: true },
      { p: 'detailY', o: true }
    ],
    p5: true
  },
  {
    text: 'sphere',
    type: 'fun',
    params: [
      { p: 'radius', o: true },
      { p: 'detailX', o: true },
      { p: 'detailY', o: true }
    ],
    p5: true
  },
  {
    text: 'cylinder',
    type: 'fun',
    params: [
      { p: 'radius', o: true },
      { p: 'height', o: true },
      { p: 'detailX', o: true },
      { p: 'detailY', o: true },
      { p: 'bottomCap', o: true },
      { p: 'topCap', o: true }
    ],
    p5: true
  },
  {
    text: 'cone',
    type: 'fun',
    params: [
      { p: 'radius', o: true },
      { p: 'height', o: true },
      { p: 'detailX', o: true },
      { p: 'detailY', o: true },
      { p: 'cap', o: true }
    ],
    p5: true
  },
  {
    text: 'ellipsoid',
    type: 'fun',
    params: [
      { p: 'radiusX', o: true },
      { p: 'radiusY', o: true },
      { p: 'radiusZ', o: true },
      { p: 'detailX', o: true },
      { p: 'detailY', o: true }
    ],
    p5: true
  },
  {
    text: 'torus',
    type: 'fun',
    params: [
      { p: 'radius', o: true },
      { p: 'tubeRadius', o: true },
      { p: 'detailX', o: true },
      { p: 'detailY', o: true }
    ],
    p5: true
  },
  {
    text: 'orbitControl',
    type: 'fun',
    params: [
      { p: 'sensitivityX', o: true },
      { p: 'sensitivityY', o: true },
      { p: 'sensitivityZ', o: true },
      { p: 'options', o: true }
    ],
    p5: true
  },
  { text: 'debugMode', type: 'fun', p5: true },
  { text: 'noDebugMode', type: 'fun', p5: true },
  { text: 'ambientLight', type: 'fun', p5: true },
  { text: 'specularColor', type: 'fun', p5: true },
  { text: 'directionalLight', type: 'fun', p5: true },
  { text: 'pointLight', type: 'fun', p5: true },
  {
    text: 'imageLight',
    type: 'fun',
    params: [{ p: 'img', o: false }],
    p5: true
  },
  { text: 'panorama', type: 'fun', params: [{ p: 'img', o: false }], p5: true },
  { text: 'lights', type: 'fun', p5: true },
  {
    text: 'lightFalloff',
    type: 'fun',
    params: [
      { p: 'constant', o: false },
      { p: 'linear', o: false },
      { p: 'quadratic', o: false }
    ],
    p5: true
  },
  { text: 'spotLight', type: 'fun', p5: true },
  { text: 'noLights', type: 'fun', p5: true },
  { text: 'loadModel', type: 'fun', p5: true },
  { text: 'model', type: 'fun', params: [{ p: 'model', o: false }], p5: true },
  {
    text: 'loadShader',
    type: 'fun',
    params: [
      { p: 'vertFilename', o: false },
      { p: 'fragFilename', o: false },
      { p: 'successCallback', o: true },
      { p: 'failureCallback', o: true }
    ],
    p5: true
  },
  {
    text: 'createShader',
    type: 'fun',
    params: [
      { p: 'vertSrc', o: false },
      { p: 'fragSrc', o: false }
    ],
    p5: true
  },
  {
    text: 'createFilterShader',
    type: 'fun',
    params: [{ p: 'fragSrc', o: false }],
    p5: true
  },
  { text: 'shader', type: 'fun', params: [{ p: 's', o: false }], p5: true },
  { text: 'resetShader', type: 'fun', p5: true },
  { text: 'texture', type: 'fun', params: [{ p: 'tex', o: false }], p5: true },
  {
    text: 'textureMode',
    type: 'fun',
    params: [{ p: 'mode', o: false }],
    p5: true
  },
  {
    text: 'textureWrap',
    type: 'fun',
    params: [
      { p: 'wrapX', o: false },
      { p: 'wrapY', o: true }
    ],
    p5: true
  },
  { text: 'normalMaterial', type: 'fun', p5: true },
  { text: 'ambientMaterial', type: 'fun', p5: true },
  { text: 'emissiveMaterial', type: 'fun', p5: true },
  { text: 'specularMaterial', type: 'fun', p5: true },
  {
    text: 'shininess',
    type: 'fun',
    params: [{ p: 'shine', o: false }],
    p5: true
  },
  {
    text: 'metalness',
    type: 'fun',
    params: [{ p: 'metallic', o: false }],
    p5: true
  },
  {
    text: 'camera',
    type: 'fun',
    params: [
      { p: 'x', o: true },
      { p: 'y', o: true },
      { p: 'z', o: true },
      { p: 'centerX', o: true },
      { p: 'centerY', o: true },
      { p: 'centerZ', o: true },
      { p: 'upX', o: true },
      { p: 'upY', o: true },
      { p: 'upZ', o: true }
    ],
    p5: true
  },
  {
    text: 'perspective',
    type: 'fun',
    params: [
      { p: 'fovy', o: true },
      { p: 'aspect', o: true },
      { p: 'near', o: true },
      { p: 'far', o: true }
    ],
    p5: true
  },
  { text: 'linePerspective', type: 'fun', p5: true },
  {
    text: 'ortho',
    type: 'fun',
    params: [
      { p: 'left', o: true },
      { p: 'right', o: true },
      { p: 'bottom', o: true },
      { p: 'top', o: true },
      { p: 'near', o: true },
      { p: 'far', o: true }
    ],
    p5: true
  },
  {
    text: 'frustum',
    type: 'fun',
    params: [
      { p: 'left', o: true },
      { p: 'right', o: true },
      { p: 'bottom', o: true },
      { p: 'top', o: true },
      { p: 'near', o: true },
      { p: 'far', o: true }
    ],
    p5: true
  },
  { text: 'createCamera', type: 'fun', p5: true },
  {
    text: 'setCamera',
    type: 'fun',
    params: [{ p: 'cam', o: false }],
    p5: true
  },
  { text: 'setAttributes', type: 'fun', p5: true },
  { text: 'getAudioContext', type: 'fun', p5: true },
  {
    text: 'userStartAudio',
    type: 'fun',
    params: [
      { p: 'elements', o: true },
      { p: 'callback', o: true }
    ],
    p5: true
  },
  { text: 'getOutputVolume', type: 'fun', p5: true },
  {
    text: 'outputVolume',
    type: 'fun',
    params: [
      { p: 'volume', o: false },
      { p: 'rampTime', o: true },
      { p: 'timeFromNow', o: true }
    ],
    p5: true
  },
  { text: 'soundOut', type: 'var', params: [], p5: true },
  { text: 'sampleRate', type: 'fun', p5: true },
  {
    text: 'freqToMidi',
    type: 'fun',
    params: [{ p: 'frequency', o: false }],
    p5: true
  },
  {
    text: 'midiToFreq',
    type: 'fun',
    params: [{ p: 'midiNote', o: false }],
    p5: true
  },
  {
    text: 'soundFormats',
    type: 'fun',
    params: [{ p: 'formats', o: true }],
    p5: true
  },
  {
    text: 'saveSound',
    type: 'fun',
    params: [
      { p: 'soundFile', o: false },
      { p: 'fileName', o: false }
    ],
    p5: true
  },
  {
    text: 'loadSound',
    type: 'fun',
    params: [
      { p: 'path', o: false },
      { p: 'successCallback', o: true },
      { p: 'errorCallback', o: true },
      { p: 'whileLoading', o: true }
    ],
    p5: true
  },
  {
    text: 'createConvolver',
    type: 'fun',
    params: [
      { p: 'path', o: false },
      { p: 'callback', o: true },
      { p: 'errorCallback', o: true }
    ],
    p5: true
  },
  {
    text: 'setBPM',
    type: 'fun',
    params: [
      { p: 'BPM', o: false },
      { p: 'rampTime', o: false }
    ],
    p5: true
  },
  { text: 'true', type: 'boolean', p5: 'boolean' },
  { text: 'false', type: 'boolean', p5: 'boolean' },
  { text: 'await', type: 'keyword', p5: false },
  { text: 'break', type: 'keyword', p5: false },
  { text: 'case', type: 'keyword', p5: false },
  { text: 'catch', type: 'keyword', p5: false },
  { text: 'class', type: 'keyword', p5: 'class' },
  { text: 'const', type: 'keyword', p5: 'const' },
  { text: 'continue', type: 'keyword', p5: false },
  { text: 'debugger', type: 'keyword', p5: false },
  { text: 'default', type: 'keyword', p5: false },
  { text: 'delete', type: 'keyword', p5: false },
  { text: 'do', type: 'keyword', p5: false },
  { text: 'else', type: 'keyword', p5: 'if-else' },
  { text: 'export', type: 'keyword', p5: false },
  { text: 'extends', type: 'keyword', p5: false },
  { text: 'finally', type: 'keyword', p5: false },
  { text: 'for', type: 'keyword', p5: 'for' },
  { text: 'function', type: 'keyword', p5: 'function' },
  { text: 'if', type: 'keyword', p5: 'if-else' },
  { text: 'import', type: 'keyword', p5: false },
  { text: 'in', type: 'keyword', p5: false },
  { text: 'instanceof', type: 'keyword', p5: false },
  { text: 'new', type: 'keyword', p5: false },
  { text: 'return', type: 'keyword', p5: 'return' },
  { text: 'super', type: 'keyword', p5: false },
  { text: 'switch', type: 'keyword', p5: false },
  { text: 'this', type: 'keyword', p5: false },
  { text: 'throw', type: 'keyword', p5: false },
  { text: 'try', type: 'keyword', p5: false },
  { text: 'typeof', type: 'keyword', p5: false },
  { text: 'var', type: 'keyword', p5: false },
  { text: 'void', type: 'keyword', p5: false },
  { text: 'while', type: 'keyword', p5: 'while' },
  { text: 'with', type: 'keyword', p5: false },
  { text: 'yield', type: 'keyword', p5: false },
  { text: 'let', type: 'keyword', p5: 'let' },
  { text: 'Array', type: 'obj', p5: false },
  { text: 'Boolean', type: 'obj', p5: false },
  { text: 'Date', type: 'obj', p5: false },
  { text: 'Error', type: 'obj', p5: false },
  { text: 'Function', type: 'obj', p5: false },
  { text: 'JSON', type: 'obj', p5: 'JSON' },
  { text: 'Math', type: 'obj', p5: false },
  { text: 'Number', type: 'obj', p5: false },
  { text: 'Object', type: 'obj', p5: false },
  { text: 'RegExp', type: 'obj', p5: false },
  { text: 'String', type: 'obj', p5: false },
  { text: 'Promise', type: 'obj', p5: false },
  { text: 'Set', type: 'obj', p5: false },
  { text: 'Map', type: 'obj', p5: false },
  { text: 'Symbol', type: 'obj', p5: false },
  { text: 'WeakMap', type: 'obj', p5: false },
  { text: 'WeakSet', type: 'obj', p5: false },
  { text: 'ArrayBuffer', type: 'obj', p5: false },
  { text: 'DataView', type: 'obj', p5: false },
  { text: 'Int32Array', type: 'obj', p5: false },
  { text: 'Uint32Array', type: 'obj', p5: false },
  { text: 'Float32Array', type: 'obj', p5: false },
  { text: 'window', type: 'obj', p5: false },
  { text: 'document', type: 'obj', p5: false },
  { text: 'navigator', type: 'obj', p5: false },
  { text: 'console', type: 'obj', p5: 'console' },
  { text: 'localStorage', type: 'obj', p5: false },
  { text: 'sessionStorage', type: 'obj', p5: false },
  { text: 'history', type: 'obj', p5: false },
  { text: 'location', type: 'obj', p5: false }
];
